import * as arrayUtils from './array'
import * as dateUtils from './date'
import * as numberUtils from './number'
import * as stringUtils from './string'

// Re-export helpers as it to ease direct access
export * from './array'
export * from './date'
export * from './number'
export * from './string'
export { default as AsyncStorage } from './AsyncStorage'

// Export full set of helpers in a single object namespaced by "type"
// (backward compatibility)
export default {
    array: arrayUtils,
    date: dateUtils,
    number: numberUtils,
    string: stringUtils,
}
